import { Injectable } from '@angular/core';
import { UrlService } from '../shared/services/url/url.service';
import { CalculatorService } from '../shared/services/calculator/calculator.service';
import { DocumentDataBuilder } from '../document-data/document-data.builder';
import { CreditMemo } from './credit-memo.model';
import { DateTimeService } from 'i2g-ng-utils';
import {
  ALL_LIST_FILTER,
  IFetchFilterKey,
} from '../entity-data/entity-data.data';
import { EntityTypesEnum } from '../../app.enum';
import { DocumentTypesEnum } from '../document-data/document-data.data';
import { CREDIT_MEMO_LIST_SEARCH_PARAMS } from './credit-memo-data.data';
import { UtilsService } from '../shared/services/utils/utils.service';
import { Toggles } from '../features-data/sub-models/toggles.model';
import { AccountQuotas } from '../features-data/sub-models/account-quotas.model';
import { EmailService } from '../shared/services/email/email.service';
import { TranslateService } from '@ngx-translate/core';
import { MoneyPipe } from '../shared/pipes/money/money.pipe';
import { FriendlyDatePipe } from '../shared/pipes/friendly-date/friendly-date.pipe';

@Injectable()
export class CreditMemoDataBuilder extends DocumentDataBuilder<CreditMemo> {
  model = CreditMemo;
  entityType: EntityTypesEnum = EntityTypesEnum.credit_memo;
  documentType: DocumentTypesEnum = DocumentTypesEnum.credit_memo;
  quotaName = AccountQuotas.KEYS.CREDIT_MEMOS;
  featureName: string = Toggles.KEYS.CREDIT_MEMO;
  listFilterKeys: IFetchFilterKey = {
    [ALL_LIST_FILTER]: CREDIT_MEMO_LIST_SEARCH_PARAMS,
  };

  constructor(
    dateTimeService: DateTimeService,
    calculatorService: CalculatorService,
    utilsService: UtilsService,
    emailService: EmailService,
    translateService: TranslateService,
    moneyPipe: MoneyPipe,
    friendlyDatePipe: FriendlyDatePipe,
    urlService: UrlService
  ) {
    super(
      dateTimeService,
      calculatorService,
      utilsService,
      emailService,
      translateService,
      moneyPipe,
      friendlyDatePipe,
      urlService
    );
  }
}
